import { GetOauthAuthorizationUrlResponseDto } from "@common/dto/oauth/get-oauth-authorization-url-response.dto";
import { OAuthServiceType } from "@common/constants";
import { StripeLanding } from "@common/schemas/oauth.schema";
import { backendClient, unwrapResponse } from "./backendClient";

export interface OAuthAuthorizationResponse {
    code: string;
    state?: string | null;
    additionalParams: any;
}

interface TriggerAuthorizationOptions {
    state?: string;
    stripeLanding?: StripeLanding;
}

export function triggerAuthorization(
    service: string,
    options: TriggerAuthorizationOptions = {},
): Window | null {
    const popup = window.open("about:blank", "OAuth Authorization");
    void getOAuthAuthorizationUrl(service, options)
        .then(({ url }) => {
            if (popup && !popup.closed) {
                popup.location.href = url;
            }
        })
        .catch(() => {
            popup?.close();
        });
    return popup;
}

export async function getOAuthAuthorizationUrl(
    service: string,
    options?: any,
): Promise<GetOauthAuthorizationUrlResponseDto> {
    return await unwrapResponse(
        await backendClient.get(`/oauth/authorization-url/${service}`, {
            params: options,
        }),
    );
}

export function getAdditionalOAuthAuthorizationResponseParams(
    serviceType: OAuthServiceType,
    params: URLSearchParams,
): any {
    if (serviceType === OAuthServiceType.QUICKBOOKS) {
        return { realmId: params.get("realmId") };
    }
    return null;
}
